import Login from "../components/Login/LoginPage";

const LoginPage:  React.FC = () => {
    return(
        <Login />
    );
}
export default LoginPage;